import { Outlet } from 'react-router-dom';
// @mui
import { Box, Container } from '@mui/material';
// hooks
// components
//
import CreatePasswordPrompt from './CreatePasswordPrompt';
import Main from './Main';
import CoursesHeader from './header/CoursesHeader';
import StudentBreadcrumbs, { StudentBreadcrumbsProvider } from './student/StudentBreadcrumbs';

// ----------------------------------------------------------------------

export default function StudentLayout() {
  return (
    <StudentBreadcrumbsProvider>
      <CoursesHeader />

      <Box
        sx={{
          display: { lg: 'flex' },
          minHeight: { lg: 1 },
        }}
      >
        <Main>
          <Container maxWidth="xl">
            <StudentBreadcrumbs />
          </Container>

          <Outlet />
        </Main>
      </Box>

      <CreatePasswordPrompt />
    </StudentBreadcrumbsProvider>
  );
}
